<h3>
    <i ng-if="item.isProtected" class="fa fa-lock" style="color: gray" title="{{'notification.template.isProtected'|translate}}"></i>
    <a ng-click="viewDetails($event, item)">
        {{ item.name }}
    </a>
    <i ng-if="item.isHtml" class="fa fa-code badge" title="{{'notification.template.isHtml'|translate}}"></i>
    <i ng-if="item.hasFooter" class="fa fa-address-card badge" title="{{'notification.template.hasFooter'|translate}}"></i>
</h3>
<div style="padding: 5px 0 0 0">
    {{ item.description }}
</div>
